import { authFetch } from "../../utils/authFetch";

const apiURL = require('./apiURL');
const fetch = authFetch;
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];




// types of action
const Types = {
  PAYSLIP_SAMPLE_CREATING: "PAYSLIP_SAMPLE_CREATING",
  PAYSLIP_SAMPLE_READY: "PAYSLIP_SAMPLE_READY",
  PAYSLIP_SAMPLE_CLEAR: "PAYSLIP_SAMPLE_CLEAR",
};

const clearSamplePayslip = () => ({
  type: Types.PAYSLIP_SAMPLE_CLEAR,
});

const creatingSamplePayslip = () => ({
  type: Types.PAYSLIP_SAMPLE_CREATING,
});

const samplePayslipReady = (url) => ({
  type: Types.PAYSLIP_SAMPLE_READY,
  url
});


const getStepFunctionState = ({
  arn,
  name,
}) => {
  return (dispatch, getState) => {

    const state = getState()

    const path = `/pdf/report-status/${arn}`

    fetch(apiURL + path , {
        // credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {

      const finished = data.data.status != "RUNNING"

      if (finished){

        if (data.data && data.data.output){
          const output = JSON.parse(data.data.output)
          dispatch(samplePayslipReady(output.url))
        }

      } else {

        setTimeout(
          () => {
            dispatch(getStepFunctionState({arn,name}))
          },
          1000
        )
      }

    })
  }
}

const generateSamplePayslip = (payslipData) => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(creatingSamplePayslip(true))

    const path = `/pdf/generateSamplePayslip`

    fetch(apiURL + path , {
        // credentials: 'include',
        method: 'POST',
        body: JSON.stringify(payslipData),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {

      const arn = data.executionArn
      // dispatch(getLeaveBalance())

      setTimeout(
        () => {
          dispatch(getStepFunctionState({arn,name:'generateSamplePayslip'}))
        },
        1000
      )
      
    })
  }
}


const Actions = {
  getStepFunctionState,
  generateSamplePayslip,
  clearSamplePayslip,
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions
